<script>
import datePicker from "@/components/datePicker.vue";
import * as dayjs from "dayjs";
import _ from "lodash";
import Multiselect from 'vue-multiselect'
import {isMobile} from "mobile-device-detect";
import Axios from "axios";

var isToday = require('dayjs/plugin/isToday')
dayjs.extend(isToday)
var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

export default ({
  name: "rfq-statewide-time",
  props: {
    value: {}
  },
  data() {
    return{
      currentDate: new Date(),
      selectTime: null,
      isMobile,
    }
  },
  computed: {
    selectTimeOptions () {
      let selectedDate = dayjs(this.value.date, 'DD/MM/YYYY')
      if (!selectedDate.isToday()) {
        return [
          '08:00 AM',
          '08:30 AM',
          '09:00 AM',
          '09:30 AM',
          '10:00 AM',
          '10:30 AM',
          '11:00 AM',
          '11:30 AM',
          '12:00 PM',
          '12:30 PM',
          '01:00 PM',
          '01:30 PM',
          '02:00 PM',
          '02:30 PM',
          '03:00 PM',
          '03:30 PM',
          '04:00 PM',
          '04:30 PM',
          '05:00 PM',
        ]
      } else {
        let now = dayjs()
        let timeStart = now.set('hour', 8).set('minute', 0).set('second', 0)
        let times = []
        let time = timeStart
        for (let i = 0; i < 40; i++) {
          time = timeStart.add(i * 15, 'minute')
          let differenceInMinutes = ((time - now) / 1000) / 60
          if (time > now && differenceInMinutes >= 30) {
            times.push(time.format('hh:mmA'))
          }
        }
        return times
      }
    },
  },
  watch: {
    // Watcher: sync selectTime with value.time (line 55)
    selectTime (val) {
      this.value.time = val
    },
  },
  components:{
    datePicker,
    Multiselect,
  },
  created() {
    if (_.isEmpty(this.value.date)) {
      this.value.date = dayjs().format('DD/MM/YYYY')
    }
    this.interval = setInterval(() => {
      this.currentDate = new Date()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.interval)
    next()
  },
  methods: {
    getToday(d) {
      return  ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayjs(d).day()]
    },
    getDayOfWeek (d) {
      let resultD = dayjs(d, 'DD/MM/YYYY').day()
      if (_.isEmpty(d)) {
        resultD = dayjs().day()
      }
      return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][resultD]
    },
    getTime(d) {
      return  dayjs(d).format('hh:mm A')
    },
  }
})
</script>

<template>
<div class="block-time">
  <div class="d-flex body-block-left-item justify-content-between">
    <div class="body-block-left-item-name">
      Select Date
    </div>
    <div class="body-block-left-item-input d-flex">
      <template>
        <date-picker v-model="value.date" class="statewide-date-picker"></date-picker>
      </template>

    </div>
    <div class="body-block-left-item-day">
      Today is: <span>{{getDayOfWeek(value.date)}}</span>
    </div>
  </div>
  <div class="d-flex body-block-left-item justify-content-between">
    <div class="body-block-left-item-name">
      Select Time
    </div>
    <div class="body-block-left-item-input d-flex">
      <multiselect
          ref="fieldSelectTime"
          v-model="selectTime"
          :options="selectTimeOptions"
          :showLabels="false"
          :option-height="32"
          :max-height="203"
          :close-on-select="true"
          placeholder="Select option"
          class="statewide-time-select"
          :class="{'statewide-time-select-mobile': isMobile}"
      ></multiselect>

    </div>
    <div class="body-block-left-item-day">
      Current Time: <span>{{getTime(currentDate)}}</span>
    </div>
  </div>
  <div class="block-time-btn">
    <button @click="$emit('backPage')" class="btn btn-outline-primary-light button-back">Back</button>
    <button @click="$emit('cancelPage')" class="btn btn-outline-primary button-cancel">Cancel</button>
    <button @click="$emit('receive')" class="btn btn-primary button-next">Add to Recvd</button>
    <button @click="$emit('send')" class="btn btn-primary button-next">Send Quote</button>
  </div>
  <div class="body-block-title">Summary</div>
  <div class="body-block-vehicle-details">Vehicle Details</div>
  <div class="d-flex body-block-left-item justify-content-between">
    <div class="body-block-left-item-name">
      Estimate Number
    </div>
    <div class="body-block-left-item-input d-flex">
      <input v-model="value.QPNumber" type="text">
    </div>
    <div class="body-block-left-item-day">
    </div>
  </div>
  <div style="margin-top: 40px" class="d-flex body-block-left-item justify-content-between">
    <div class="body-block-left-item-name">
      Comments
    </div>
    <div class="body-block-left-item-input d-flex">
      <textarea v-model="value.comments"></textarea>
    </div>
    <div class="body-block-left-item-day">
    </div>
  </div>
  <div class="block-time-btn">
    <button @click="$emit('backPage')" class="btn btn-outline-primary-light button-back">Back</button>
    <button @click="$emit('cancelPage')" class="btn btn-outline-primary button-cancel">Cancel</button>
    <button @click="$emit('send')" class="btn btn-primary button-next">Send Quote</button>
  </div>
</div>
</template>

<style scoped>
.block-time{
  width: 80%;
  padding: 30px 0;
}
.body-block-left-item{
  margin-top: 10px;
}
.body-block-left-item-name{
  font-weight: 700;
  font-size: 15px;
  line-height: 16px;
  padding-top: 6px;
  width: 25%;
}
.body-block-left-item-input{
  width: 40%;
}
.body-block-left-item-input >>> .form-control{
  min-width: 230px;
}
.body-block-left-item-day{
  font-weight: 400;
  font-size: 15px;
  line-height: 16px;
  padding-top: 6px;
  width: 35%;
}
.body-block-left-item-day span{
  font-weight: 800;
}
.block-time-btn{
  margin-top: 50px;
  height: 45px;
  padding: 0 50px;
}
.block-time-btn button{
  margin: 0 10px;
  width: 130px;
}
.body-block-title{
  margin-bottom: 25px;
  margin-top: 40px;
  font-weight: 600;
  font-size: 19px;
}
.body-block-vehicle-details{
  margin: 40px 0;
  font-weight: 600;
  padding: 10px 20px;
  background-color: #f0f0f0;
  font-size: 15px;
  border-radius: 4px;
}
.body-block-left-item-input input,
.body-block-left-item-input textarea{
  width: 230px;
  padding: 5px 10px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
  font-size: 13px;
}
.body-block-left-item-input textarea{
  height: 120px;
  resize: none;
}
/* Multiselect time dropdown styles (lines 243-254) */
.statewide-time-select{
  width: 230px;
  min-height: 34px;
  font-size: 13px;
}
.statewide-time-select >>> .multiselect__tags{
  min-height: 34px;
  padding-top: 5px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;
}
.statewide-date-picker >>> .vc-highlights.vc-day-layer .vc-highlight{
  background-color: #582b79 !important;
}
.statewide-date-picker >>> .vc-date .vc-month,
.statewide-date-picker >>> .vc-date .vc-day {
  color: #582b79 !important;
}
.statewide-date-picker >>> .vc-am-pm .active{
  background-color: #582b79 !important;
}
.statewide-date-picker >>> .vc-select select:focus{
  border-color: #582b79 !important;
}
@media (max-width: 1280px) {
  .left-block{
    width: 100% !important;
  }
  .block-time{
    width: auto;
  }
}
@media (max-width: 650px) {
  .block-time-btn{
    padding: 0;
  }
  .body-block-left-item-input >>> .form-control{
    width: 180px;
    min-width: auto;
  }
  .body-block-left-item-input input,
  .body-block-left-item-input textarea,
  .statewide-time-select-mobile{
    width: 180px;
  }
  .block-time-btn button{
    width: auto;
  }
  .body-block-left-item-day{
    margin-left: 15px;
    padding-top: 0;
  }
  .body-block-left-item-input{
    width: auto;
    margin-left: 5px;
  }
  .body-block-left-item-name{
    min-width: 80px;
  }
}
@media (max-width: 420px) {
  .body-block-left-item-input >>> .form-control,
  .statewide-time-select-mobile{
    width: 130px;
  }
}
@media (max-width: 400px) {
  .body-block-left-item-input >>> .form-control{
    min-width: 130px;
  }
  .body-block-left-item-input input,
  .body-block-left-item-input textarea{
    width: 180px;
  }
}
</style>
